import { useEffect, useState } from 'react'

import { Item } from '../../models/Item'
import { Option } from '../../models/Option'
import { Chip } from '../common/fields/Chip'

type Props = {
    onSelectOption: (option: Option) => void
    selectedOptionId: string | undefined
    isClass: boolean
}

export const VideoConferenceChips = ({ onSelectOption, selectedOptionId, isClass }: Props) => {
    const [options, setOptions] = useState<Option[]>([])

    useEffect(() => {
        ;(async () => {
            setOptions(await Item.videoConferenceStrings(isClass))
        })()
    }, [isClass])

    return (
        <div className="flex flex-wrap gap-2">
            {options.map((option) => (
                <Chip
                    size="small"
                    key={option.id}
                    title={option.subtitle ?? ''}
                    isSelected={option.id === selectedOptionId}
                    onClick={() => onSelectOption(option)}
                />
            ))}
        </div>
    )
}
